import { useEffect, useState } from 'react';
import { Home } from './screens/Home';
import { RoomScreen } from './screens/RoomScreen';

const ROOM_PATH = /^\/sala\/([A-Za-z]{4})\/?$/;

function readRoute(): { room: string | null } {
  const m = location.pathname.match(ROOM_PATH);
  return { room: m ? m[1]!.toUpperCase() : null };
}

export function navigate(path: string): void {
  history.pushState(null, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function App() {
  const [route, setRoute] = useState(readRoute);
  useEffect(() => {
    const on = () => setRoute(readRoute());
    window.addEventListener('popstate', on);
    return () => window.removeEventListener('popstate', on);
  }, []);
  return route.room ? <RoomScreen key={route.room} code={route.room} /> : <Home />;
}
